import classNames from 'classnames';
import * as React from 'react';

import { useDropZoneInit } from '../../hooks/use-drop-zone-init';
import BodyDropzone from '../../subcomponents/body-dropzone';
import { Dropzone } from '../../subcomponents/dropzone';
import { Format } from '../../subcomponents/format';
import Image from '../../subcomponents/image';
import { FormDropZoneVariantProps } from '../../types';
import { Container } from '../styles';

export const UnionDropzone: React.FC<FormDropZoneVariantProps> = (props) => {
  const { disabled } = props;
  const { images, ...rest } = useDropZoneInit({ name: props.name, disabled });

  const image = (Array.isArray(images) ? images[0] : images) as File | string | undefined;

  const data = React.useMemo(() => {
    if (typeof image === 'string') return { url: image, alt: 'Изображение' };
    if (image instanceof File) return { url: URL.createObjectURL(image), alt: image.name };
    return undefined;
  }, [image]);

  return (
    <Container className={props.className}>
      <Dropzone
        {...rest}
        className={classNames('mb-2 flex flex-row', { disabled })}
        style={{ justifyContent: images.length > 0 ? 'flex-start' : 'center', padding: '20px' }}
      >
        {data && <Image src={data.url} alt={data.alt} />}
        <BodyDropzone
          title={props.title}
          subtitle={props.subtitle}
          buttonText={props.buttonText}
          onButtonClick={props.onButtonClick}
          className="w-full"
        />
      </Dropzone>
      <div className="flex w-full">
        <Format />
      </div>
    </Container>
  );
};
